import React, { useState } from "react";

export default function AnunturiPage() {
  const anunturi = [
    {
      name: "Evaluare Națională",
      link: "/evaluare-nationala",
      date: "21.06.2026"
    },
    {
      name:"Anunt promovare treapta profesionala",
      file:"Anunt promovare treapta profesionala.PDF",
      date:"04.05.2026"
    },
    {
      name: "EURO 200",
      file: "ADRESA EURO 200 CU INREGISTRARE ISJMM.pdf",
      date: "27.04.2026"
    },
    {
      name: "Program 'Școala Altfel'",
      file: "Program scoala altfel.PDF",
      date: "27.10.2025"
    },
    {
      name: "Tematică consiliul profersorilor",
      file: "Tematica CP.PDF",
      date: "20.09.2025"
    },
    {
      name: "Anunț burse școlare 2025-2026",
      file: "Anunț burse școlare 2025-2026.pdf",
      date: "15.09.2025",
    },
    {
      name: "Rezultate finale - inspecții la clasă - Pretransfer",
      file: "Rezultate finale - inspecții la clasă - Pretransfer.PDF",
      date: "11.04.2025",
    },
    {
      name: "Procedură operațională privind Organizarea și desfășurarea inspecțiilor speciale la clasă la etapa de pretransfer",
      file: "PO-C.40 .1 Procedură operațională privind Organizarea și desfășurarea inspecțiilor speciale la clasă la etapa de pretransfer.pdf",
      date: "05.01.2024",
    },
    {
      name: "Condiții specifice de ocupare a posturilor didactice/catedrelor vacante în cadrul etapelor de transfer/pretransfer consimțit între unitățile de învățământ",
      file: "CONDITII SPECIFICE DE OCUPARE POSTURI DIDACTICE.pdf",
      date: "05.01.2024",
    },
    {
      name: "Rezultate finale concurs decembrie 2023",
      file: "anunt rezultate finale concurs dec 2023.pdf",
      date: "05.01.2024",
    },
    {
      name: "Rezultate proba de interviu decembrie 2023",
      file: "anunt rezultat proba de interviu_decembrie 2023.pdf",
      date: "28.12.2023",
    },
    {
      name: "Rezultate proba practică decembrie 2023",
      file: "anunt rezultat proba practica_decembrie 2023.pdf",
      date: "28.12.2023",
    },
    {
      name: "Selecție dosar concurs decembrie 2023",
      file: "anunt-selectie dosar-concurs decembrie 2023.pdf",
      date: "20.12.2023",
    },
    {
      name: "Calendar concurs decembrie 2023",
      file: "calendar concurs decembrie 2023.pdf",
      date: "04.12.2023",
    },
    {
      name: "PRIMA LISTĂ CU BENEFICIARII DE BURSE ÎN ANUL ȘCOLAR 2023-2024",
      file: "BURSE AFISAT REZULTATE.pdf",
      date: "18.10.2023",
    },
    {
      name: "Rezultate concurs",
      file: "REZULTATE FINALE.pdf",
      date: "03.10.2023",
    },
    {
      name: "Rezultate interviu",
      file: "rezultat proba inteviu.pdf",
      date: "02.10.2023",
    },
    {
      name: "Rezultate proba scrisă",
      file: "REZULTATE FINALE PROBA SCRISA.pdf",
      date: "02.10.2023",
    },
    { name: "Calendar concurs", file: "calendar.pdf", date: "26.09.2023" },
    {
      name: "Posturi vacante anul școlar 2023-2024",
      file: "Anunț.pdf",
      date: "26.09.2023",
    },
    {
      name: "Centralizator-Posturi vacante anul școlar 2023-2024",
      file: "centralizare_macheta_posturi_vacante_2022_2023.pdf",
      date: "26.09.2023",
    },
    {
      name: "Program pentru utilizarea terenului de sport al Liceului Tehnologic ”Dr. Florian Ulmeanu„ Ulmeni",
      file: "program teren de sport.pdf",
      date: "15.05.2023",
    },
    {
      name: "Broșura de admitere",
      file: "2023-2024-brosura-admitere-inv-liceal-profesional-&-dual-de-stat-&-privat.pdf",
      date: "15.05.2023",
    },
    {
      name: "Examen de corigență 2022-2023",
      file: "Notă - examen corigență 2022-2023.pdf",
      date: "12.05.2023",
    },
    {
      name: "Anunț concurs pentru un post contractual",
      file: "Liceul Tehnologic Dr. F. Ulmeanu Ulmeni - revenire anunț post . posturi .gov..pdf",
      date: "15.03.2023",
    },
    {
      name: "Rezultat concurs",
      file: "rezuyltat final concurs ingrijitor 2021 dec.pdf",
      date: "30.12.2022",
    },
    {
      name: "Rezultat selectie dosar",
      file: "rezultate selectie dosar 12.pdf",
      date: "20.12.2022",
    },
    {
      name: "Anunț - concurs organizat pentru ocuparea postului vacant - îngrijitor de curățenie",
      file: "anunt ingrijitor curatenie.pdf",
      date: "09.12.2022",
    },
    {
      name: "Rezultate finale - concurs organizat pentru ocuparea postului vacant - administrator financiar",
      file: "anunt rezultate finale.pdf",
      date: "20.07.2022",
    },
    {
      name: "Programare proba de interviu - Concurs post administrator financiar",
      file: "programare proba de interviu.pdf",
      date: "19.07.2022",
    },
    {
      name: "Rezultatul concursului organizat în vederea ocupării funcției vacant de paznic",
      file: "rezutat concurs paznic.pdf",
      date: "18.07.2022",
    },
    {
      name: "Rezultatul la proba scrisa la concursul organizat in vederea ocupării postului de Administrator financiar",
      file: "rezultat proba scrisa concurs administrator financiar.pdf",
      date: "18.07.2022",
    },
    {
      name: "Rezultatul final la proba selecției dosarelor la concurs_post vacant de paznic",
      file: "anunt_selectie dosar_paznic.pdf",
      date: "14.07.2022",
    },
    {
      name: "Anunț în atenția candidaților",
      file: "anunt candidat.pdf",
      date: "14.07.2022",
    },
    {
      name: "Rezultatul final la proba selecției dosarelor la concurs_Administrator financiar",
      file: "rezultat selectie dosar adm financiar.pdf",
      date: "14.07.2022",
    },
    {
      name: "Anunț concurs pentru post contractual - paznic",
      file: "concurs paznic.pdf",
      date: "29.06.2022",
    },
    {
      name: "	Concurs pt. ocuparea pe perioada nedeterminata a postului contractual vacant, de administrator financiar",
      file: "concurs contabil.pdf",
      date: "29.06.2022",
    },
    {
      name: "Rezultatul concursului pentru ocuparea postului de șofer, categoria D- pentru microbuzul școlar",
      file: "rezultat concurs sofer 2021.pdf",
      date: "10.12.2021",
    },
    {
      name: "Calendarul concursului pentru ocuparea postului de șofer, categoria D- pentru microbuzul școlar",
      file: "calendar concurs.pdf",
      date: "25.11.2021",
    },
    {
      name: "Concurs pentru ocuparea postului de șofer, categoria D (1 normă)",
      file: "concurs sofer_anunt.pdf",
      date: "19.11.2021",
    },
    {
      name: "Concurs de ocupare a posturilor didactice/ catedrelor Care se vacanteaza pe parcursul anului școlar în unitațile de învațamânt preuniversitar de stat 2021-2022",
      file: "anunt 2021 catedre.pdf",
      date: "04.11.2021",
    },
    {
      name: "Anunt concurs_0,5 norma.pdf",
      file: "Anunt concurs_0,5 norma.pdf",
      date: "22.02.2021",
    },
    {
      name: "Grafic concurs proba scrisa",
      file: "GRAFIC PROBA SCRISA  _site.pdf",
      date: "08.01.2021",
    },
    {
      name: "Anunt concurs pentru ocuparea unui post vacant",
      file: "concurs site 2021 ANEXA 2.pdf",
      date: "06.01.2021",
    },
    {
      name: "Rezultate concurs pentru ocuparea unui post de educator",
      file: "rezultate-finale-cocors-educator-2019.pdf",
      date: "25.10.2019",
    },
    {
      name: "Anunt-concurs pentru ocuparea catedrelor: Educatie plastica (7ore) si Limba maghiara materna(3 ore_)",
      file: "anunt concurs desen si lb maghiara.pdf",
      date: "18.10.2019",
    },
  ];

  const [visibleCount, setVisibleCount] = useState(3);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 10);
  };

  const handleShowLess = () => {
    setVisibleCount(3);
  };

  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h2 className="text-xl font-bold mt-8 mb-4">Anunțuri</h2>
        <ul>
         {anunturi.slice(0, visibleCount).map((anunt) => (
            <li key={anunt.file || anunt.link} className="mb-2 flex items-center">
              <span className="text-gray-500 font-medium mr-2">
                {anunt.date}
              </span>

              <span className="font-bold text-xl mr-2">{anunt.name}</span>

              <a
                href={anunt.link ? anunt.link : `/anunturi/${anunt.file}`}
                target={anunt.link ? "_self" : "_blank"}
                rel={anunt.link ? undefined : "noopener noreferrer"}
                className="ml-4 text-blue-600 underline"
              >
                Deschide
              </a>
            </li>
          ))}
        </ul>
        <div className="mt-4 flex space-x-4">
          {visibleCount < anunturi.length && (
            <button
              onClick={handleShowMore}
              className="px-4 py-2 rounded"
              style={{
                backgroundColor: "rgba(170,190,107,0.8)",
                color: "black",
              }}
              onMouseEnter={(e) =>
                (e.target.style.backgroundColor = "rgba(170,190,107,1)")
              }
              onMouseLeave={(e) =>
                (e.target.style.backgroundColor = "rgba(170,190,107,0.8)")
              }
            >
              Arată mai multe
            </button>
          )}
          {visibleCount > 3 && (
            <button
              onClick={handleShowLess}
              className="px-4 py-2 rounded"
              style={{
                backgroundColor: "red",
                color: "white",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "darkred")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "red")}
            >
              Ascunde
            </button>
          )}
        </div>
      </main>
    </div>
  );
}
